import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetPayrollReport = async (startDate, endDate, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {        
      const queryParams = {
        startDate: startDate || '',
        endDate: endDate || ''
      }
      
      const response = await fetch(`${dev_baseUrl}/Reports/get-employee-hours-report`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(queryParams),
      });
      
      const data = await response.json();                           
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else if(response.ok && !data.isError ){      
        return data;
      }       
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
